import React from "react";
import locale from "locale";
import {
    Breadcrumb,
    DropdownButton,
    MenuItem,
    Col,
    Row,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import { REMINDER_TYPES } from "../constants";

const RemindersBreadcrumbs = ({ event, onCreateReminder }) => {
    return (
        <Row>
            <Col xs={10}>
                <Breadcrumb>
                    <LinkContainer to={`/event/${event.eventPassword}`}>
                        <Breadcrumb.Item>
                            {locale("reminders.broadcast")}
                        </Breadcrumb.Item>
                    </LinkContainer>
                    <Breadcrumb.Item active>
                        {locale("reminders.mailing")}
                    </Breadcrumb.Item>
                </Breadcrumb>
            </Col>
            <Col xs={2} style={{ textAlign: "right" }}>
                <DropdownButton
                    id="createReminderButton"
                    title={locale("reminders.addMailing")}
                    pullRight
                    onSelect={(type) => onCreateReminder(type)}
                >
                    {Object.keys(REMINDER_TYPES).map((type) => (
                        <MenuItem
                            key={type}
                            eventKey={type}
                            id={`createReminder_${type}`}
                        >
                            {REMINDER_TYPES[type]}
                        </MenuItem>
                    ))}
                </DropdownButton>
            </Col>
        </Row>
    );
};

export default RemindersBreadcrumbs;
